// extracted by mini-css-extract-plugin
module.exports = {"root":"ClientCreditCards_root__2-n9i","cards":"ClientCreditCards_cards__3Ip2g","empty":"ClientCreditCards_empty__3LoZb"};